import { computed, Ref, ref, useId } from 'vue';

export function useInputField(modelValue: Ref<string | undefined>, onFocus?: () => void) {
  const inputId = useId();
  const labelId = useId();

  const isFocused = ref(false);
  const focusedBefore = ref(false);

  const hasContent = computed(() => !!modelValue.value && modelValue.value.length > 0);

  const handleFocus = () => {
    isFocused.value = true;
    onFocus?.();
  };

  const handleBlur = () => {
    isFocused.value = false;
    focusedBefore.value = true;
  };

  return {
    inputId,
    labelId,
    isFocused,
    focusedBefore,
    hasContent,
    handleFocus,
    handleBlur,
  };
}
